<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR NIVEL EDUCATIVO</h1>
            <div class="title-lists">
                {{ selectedEducation?.outsider?.identificationCode }} -
                {{ selectedEducation?.outsider?.name }}
                {{ selectedEducation?.outsider?.lastName }}
            </div>
        </div>
        <div class="form-body">
            <form
                [formGroup]="editEducationForm"
                (ngSubmit)="updateEducation()"
            >
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Nivel educativo</mat-label>
                            <mat-select
                                matInput
                                placeholder="Nivel educativo"
                                formControlName="level"
                            >
                                <mat-option
                                    *ngFor="let e of educationLevel"
                                    [value]="e.value"
                                    >{{ e.value }}</mat-option
                                >
                            </mat-select>
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editEducationForm
                                        .get('level')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Educación propia</mat-label>
                            <input
                                matInput
                                placeholder="Educación propia"
                                formControlName="culturalKnowledge"
                                oninput="this.value = this.value.toUpperCase()"
                            />
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editEducationForm
                                        .get('culturalKnowledge')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Nasa Yuwe</mat-label>
                            <mat-select
                                matInput
                                placeholder="Nasa Yuwe"
                                formControlName="nasaYuwe"
                            >
                                <mat-option
                                    *ngFor="let e of lengueageProperty"
                                    [value]="e.value"
                                    >{{ e.label }}</mat-option
                                >
                            </mat-select>
                            <mat-error
                                class="for-text text-danger"
                                *ngIf="
                                    editEducationForm
                                        .get('nasaYuwe')
                                        ?.hasError('required')
                                "
                            >
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox
                                class="example-margin"
                                formControlName="isIlliterate"
                                >¿Es analfabeta?</mat-checkbox
                            >
                        </section>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"
                        ><mat-icon>save</mat-icon>Guardar</span
                    >
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"
                        ><mat-icon>close</mat-icon>Cancelar</span
                    >
                </button>
            </form>
        </div>
    </div>
</div>
